import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useDetailStyles from '../detail-styles'

const DetailSection = ({ title, children }) => {
  const classes = useDetailStyles()

  if (!children) {
    return null
  }

  return (
    <Box className={classes.section}>
      {title ? (
        <Typography component="h2" className={classes.sectionEyebrow}>
          {title}
        </Typography>
      ) : null}
      <Box className={classes.sectionCard}>{children}</Box>
    </Box>
  )
}

DetailSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}

export default DetailSection
